export default __webpack_public_path__ + "static/media/Emblem_Gold.8311fbf3.webp";